module.exports = __webpack_public_path__ + "static/media/goddiva-small.e2a7d9e2.png";